import { ReadStream } from "fs";

import { IActionResult } from "./Results/CustomActionResultHandler";
import { HtmlResultHandler } from "./Results/HtmlResultHandler";

export function httpRedirect(target: string): IActionResult {
    return async (_, res) => {
        res.redirect(target);
    };
}

export function httpHtmlResult(content: string): IActionResult {
    const resultHandler = new HtmlResultHandler();
    return async (req, res) => {
        await resultHandler.processResult(content, req, res);
    };
}

export function httpContentResult(content: Buffer | string, contentType: string | false): IActionResult {
    return async (_, res) => {
        if (contentType) {
            res.contentType(contentType);
        }
        res.send(content);
    };
}

export function httpStreamResult(result: ReadStream, contentType: string | false): IActionResult {
    return async (_, res): Promise<void> => {
        if (contentType) {
            res.header("Content-Type", contentType);
        }
        result.pipe(res);
    };
}
